export default __webpack_public_path__ + "static/media/paymentplan.91295f97.avif";